

  <div   *ngFor="let siteName of distinctSiteName ">
    <mat-card class="mat-elevation-z8">
      <mat-card-title class="dgitems site-title">
        <span> {{ siteName }}</span>
      </mat-card-title>
      <mat-card-content>
        <app-dosinggoals [site]="getSiteSpecificGoals(siteName)"></app-dosinggoals>
      </mat-card-content>
    </mat-card>
     <br/>
  </div>


